import React from "react";
import { Link } from "gatsby";

const Bar = ({ trial }) => (
  <section className="section ctaSection">
    <div className="container">
      <div className="columns is-vcentered">
        <div className="column cta has-text-centered">
          <div>Get Started with Dripstat</div>
          {trial && <div className="trial">Free 14 day Pro Trial</div>}
        </div>
        <div className="column">
          <Link className="button is-large" to="/signup">
            Start Dripping
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default Bar;
